export const environment = {
  production: true,
  REGION: 'us-east-1',
  USER_POOL_ID: 'us-east-1_niLFMZMRn',
  APP_CLIENT_ID: '15goj6btr0hvv490pe3mbm6coe',
  COGNITO_HOSTED_UI: 'https://testtw.auth.us-east-1.amazoncognito.com',

  OMNISMART_API: 'https://api-gateway-prd.omnismart.app/',

  IS_DEVELOPMENT: false,

  AI_AGENT_V2_ENABLED: false,

  OMNISMART_API_ATTENDANCE_REPORTS: 'https://omni-attendance-prd.omnismart.app/',
  OMNISMART_API_CALL_HISTORY: 'https://omni-call-history-prd.omnismart.app/',
  OMNISMART_API_CHANNEL: 'https://omni-channel-prd.omnismart.app/',
  OMNISMART_API_CHAT_PERSISTENCE: 'https://omni-chat-persistence-prd.omnismart.app/',
  OMNISMART_API_CONTACTS: 'https://omni-contacts-prd.omnismart.app/',
  OMNISMART_API_CUSTOM_FORM: 'https://omni-custom-form-prd.omnismart.app/',
  OMNISMART_API_CUSTOMER: 'https://omni-customer-prd.omnismart.app/',
  OMNISMART_API_FACEBOOK: 'https://omni-facebook-prd.omnismart.app/',
  OMNISMART_API_FLOW_ENGINE: 'https://omni-flow-engine-prd.omnismart.app/',
  OMNISMART_API_FLOW: 'https://omni-flow-prd.omnismart.app/',
  OMNISMART_API_HOLIDAYS: 'https://omni-holydays-prd.omnismart.app/',
  OMNISMART_API_INSTAGRAM_DIRECT: 'https://omni-instagram-direct-prd.omnismart.app/',
  OMNISMART_API_LOGIN_REPORT: 'https://omni-attendance-prd.omnismart.app/',
  OMNISMART_API_PROTOCOL: 'https://omni-protocol-prd.omnismart.app/',
  OMNISMART_API_REPORT_PAUSE: 'https://omni-attendance-prd.omnismart.app/',
  OMNISMART_API_TAGS: 'https://omni-tags-prd.omnismart.app/',
  OMNISMART_API_TEAM: 'https://omni-teams-prd.omnismart.app/',
  OMNISMART_API_TIMELINE: 'https://omni-timeline-prd.omnismart.app/',
  OMNISMART_API_UPLOADER: 'https://omni-uploader-prd.omnismart.app/',
  OMNISMART_API_USERS: 'https://omni-users-prd.omnismart.app/',
  OMNISMART_API_AGENT: 'https://omni-virtual-agents-prd.omnismart.app/',
  OMNISMART_API_WEBHOOK: 'https://omni-webhook-prd.omnismart.app/',
  OMNISMART_API_WHATSAPP: 'https://omni-whats-prd.omnismart.app/',
  OMNISMART_API_WHATSAPP_OFICIAL: 'https://omni-whatsapp-oficial-prd.omnismart.app/',
  OMNISMART_API_WHATSAPP_OMNI: 'https://omni-whatsomni-service-prd.omnismart.app/',
  OMNISMART_API_EMAIL: 'https://omni-mail-prd.omnismart.app/',
  OMNISMART_API_PARAMETERS: 'https://omni-parameters-prd.omnismart.app/',
  OMNISMART_API_MARKETING_CAMPAIGN: 'https://omni-marketing-campaign-prd.omnismart.app/',
  OMNISMART_API_TELEGRAM: 'https://omni-telegram-service-prd.omnismart.app/',
  OMNISMART_API_LINKEDIN: 'https://omni-linkedin-prd.omnismart.app/',
  OMNISMART_API_RECLAME_AQUI: 'https://omni-reclame-aqui-prd.omnismart.app/',

  PLOOMES_API_BASE_URL: 'https://api2.ploomes.com/',

  OMNISMART_PUBLIC_API: 'https://api.omnismart.app/',
  OMNISMART_PUBLIC_API_DOCUMENTATION: 'https://documenter.getpostman.com/view/29547622/2s9YBxacS6',
  OMNISMART_API_MARKETPLACE: 'https://omni-marketplace-prd.omnismart.app/',
  OMNISMART_API_JITSI_MEET: 'https://meet.omnismart.app/',

  OMNISMART_SOCKET_URL: 'https://prd-ws.omnismart.net/',

  MEGA_API_TOKEN:
    'eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiVFcgU29sdXRpb25zIn0.9L1jzpOL26zZaa1BdTyJcirTOGl1TmMS9D22hq_QvnZFpHiErJLR_PqynCZYc2BIl6I7SMZYEWMrF4oGEYp2cw',

  AUDIO_URL_BASE:
    'https://pabxteste.twsolutions.com.br/integracao/records?key=ytsqJuGXBs0wgeBGiHkncAfb75NsPgG2eR8i&uniqueid=',

  WIDGET_URL: 'https://s3.amazonaws.com/widget.omnismart.net/widget.js',

  DIALOG_360_MIGRATE:
    'https://hub.360dialog.com/dashboard/app/pUFpo7PA/permissions?redirect_url=https%3A%2F%2Fomnismart.app%2F%23%2Fpanel%2Fchannels%2Fwhatsapp-oficial',

  JSONIP_API: 'https://ipv4.jsonip.com',
  IPINFO_API: 'https://ipinfo.io',
  GEOIP_API: 'http://ip-api.com/json',
  ANGULAR_APP_URL: 'https://omnismart.app/',
  ANGULAR_SAAS_MANAGER: 'https://saas.omnismart.app/',
  ANGULAR_APP_PABX: 'https://pabx.omnismart.app/',
  DOMAIN: 'omnismart.app',
  LOCAL_DOMAIN: 'localhost',
  API_PABX: 'https://api-pabx.omnismart.app:8883/',
};
